import { render, staticRenderFns } from "./popup-do-category.vue?vue&type=template&id=200862e6&scoped=true"
import script from "./popup-do-category.vue?vue&type=script&lang=js"
export * from "./popup-do-category.vue?vue&type=script&lang=js"
import style0 from "./popup-do-category.vue?vue&type=style&index=0&id=200862e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200862e6",
  null
  
)

export default component.exports